const e = {
  modalBottomSheet: {
    overflowY: "visible"
  }
}, o = {
  modal: {
    maxWidth: 120,
    maxHeight: "90vh"
  },
  bottomSheet: {
    height: "auto",
    minHeight: "40vh",
    maxHeight: "90vh"
  },
  modalBottomSheet: {
    maxHeight: "90vh"
  }
}, a = {
  base: {
    justifyContent: "stretch",
    pl: [5, 8],
    pt: (t) => [t.spacing(3.5), 0]
  }
}, h = {
  dialogOverlay: e,
  dialogContent: o,
  dialogHeader: a
};
export {
  h as dialogsTheme
};
